import { CALIBRATION_KIND_ORDER } from '../../constants';
import useTranslation from '../useTranslation';

import type { UseData } from './types';

const useData = (): UseData => {
    const { CALIBRATION_KIND_LABELS, NO_CALIBRATION_KINDS_FOUND } = useTranslation();

    const calibrationKindItems = CALIBRATION_KIND_ORDER.map(calibrationKind => ({
        label: CALIBRATION_KIND_LABELS[calibrationKind],
        value: calibrationKind
    }));

    return { calibrationKindItems, noItemsText: NO_CALIBRATION_KINDS_FOUND };
};

export default useData;
